module.exports = __webpack_public_path__ + "49945f41023671eafb969cea391df7a0.svg";